import { ArrowUpRight } from "lucide-react";
import { FlowSphereLogo } from "../components/FlowSphereLogo";

export const PublicNav = ({ navigate }) => (
  <header className="public-nav" data-testid="public-navigation">
    <button className="public-brand" data-testid="public-logo-button" onClick={() => navigate("/")}>
      <FlowSphereLogo variant="nav" />
    </button>
    <nav aria-label="Main navigation">
      <button data-testid="nav-how-it-works-button" onClick={() => document.getElementById("how-it-works")?.scrollIntoView({ behavior: "smooth" })}>How it works</button>
      <button data-testid="nav-product-button" onClick={() => document.getElementById("product")?.scrollIntoView({ behavior: "smooth" })}>Product</button>
      <button data-testid="nav-pricing-button" onClick={() => document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" })}>Plans</button>
    </nav>
    <div className="public-nav-actions">
      <button className="nav-login" data-testid="public-login-button" onClick={() => navigate("/login")}>Login</button>
      <button className="white-button nav-setup" data-testid="public-setup-button" onClick={() => navigate("/setup")}>Set Up My Business <ArrowUpRight size={16} /></button>
    </div>
  </header>
);